import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Injectable } from '@angular/core';
import { BehaviorSubject, from } from "rxjs";
import { delay, concatMap, tap, map, catchError } from 'rxjs/operators';
import { AuditCorrectiveActionService } from '../pages/audits/audit-corrective-action/audit-corrective-action.service';
import { Helper } from '../pages/common/helper';
import { QueueData } from '../pages/common/model/QueueData';
import { SecurityHelper } from '../pages/common/securityHelper';
import { DailyMealsEntryService } from '../pages/dailymeals/daily-meals-entry/daily-meals-entry.service';
import { DailyMealsOverviewService } from '../pages/dailymeals/daily-meals-overview/daily-meals-overview.service';
import { ShipCrewService } from '../pages/maintenance/ship-crew/ship-crew.service';
import { UserNotifMessageData } from '../pages/notification/Model/user-notif-message';
import { SupplierSurveyDto } from '../pages/orders/model/supplierSurveyDto';
import { OrderCartService } from '../pages/orders/order-cart/order-cart.service';
import { OrderItemService } from '../pages/orders/order-item/order-item.service';
import { OrderOverviewService } from '../pages/orders/order-overview/order-overview.service';
import { OrderRequestService } from '../pages/orders/order-request/order-request.service';
import { StocksListService } from '../pages/stocks/stocks-list/stocks-list.service';
import { StocksOverviewService } from '../pages/stocks/stocks-overview/stocks-overview.service';
import { StocksRequestService } from '../pages/stocks/stocks-request/stocks-request.service';
import { IfsSurveyService } from '../pages/survey/ifs-survey/ifs-survey.service';
import { CommonService } from './common.service';
import { DbContextService } from './db-context.service';
import swal from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class OfflineQueueService {

  constructor(
    private http: HttpClient,
    private dbxService: DbContextService,
    private orderItemService: OrderItemService,
    private orderCartService: OrderCartService,
    private orderRequestService: OrderRequestService,
    private dailyMealsOverviewService: DailyMealsOverviewService,
    private dailyMealsEntryService: DailyMealsEntryService,
    private stocksListService: StocksListService,
    private shipCrewService: ShipCrewService,
    private orderOverviewService: OrderOverviewService,
    private stocksOverviewService: StocksOverviewService,
    private ifsSurveyService: IfsSurveyService,
    private auditActionService: AuditCorrectiveActionService,
    private commonService: CommonService,
  ) {
  }


  pushQueueIndxdb(api: string, param: any, isAuthenticated: boolean, requestModule: string, requestID: any, queueData: any) {

    let userID = SecurityHelper.GetLoggedInUserData().userID;
    let ID = (new Date).getTime();

    const cleanParam = JSON.parse(JSON.stringify(param));

    const obj = {
      queueID: ID.toString(),
      userID: userID,
      api: api,
      param: cleanParam,
      isAuthenticated: isAuthenticated,
      requestModule: requestModule,
      requestID: requestID,
      queue: queueData
    };

    this.dbxService.openDatabase().then(db => {
      console.log('Pushed to queue');
      const tx = db.transaction('IFSOBSWS_Queue', 'readwrite');
      tx.oncomplete = (ev) => {

      }

      tx.onabort = (event: any) => {
        console.error(event);
        const err = event.target?.error;
        if (err?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      };

      tx.onerror = (event: any) => {
        console.warn(event);
        const err = event.target?.error;
        if (err?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      };

      let store = tx.objectStore('IFSOBSWS_Queue');
      try {
        store.add(obj);
      } catch (e: any) {
        console.log('ERROR', obj);
        if (e?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
        else {
          swal.fire({
            title: 'Error',
            html: `<span>${e.toString()}</span>`,
            icon: "error",
            confirmButtonText: "OK",
            allowOutsideClick: false,
            allowEscapeKey: false,
          });
        }
      }
    });
  }

  updateQueueIndxdb(api: string, param: any, isAuthenticated: boolean, requestModule: string, requestID: any, queueData: any) {

    let userID = SecurityHelper.GetLoggedInUserData().userID;
    let ID = (new Date).getTime();

    const obj = {
      queueID: ID.toString(),
      userID: userID,
      api: api,
      param: param,
      isAuthenticated: isAuthenticated,
      requestModule: requestModule,
      requestID: requestID,
      queue: queueData
    };

    this.dbxService.openDatabase().then(db => {
      console.log('Update queue');
      const tx = db.transaction('IFSOBSWS_Queue', 'readwrite');
      tx.oncomplete = (ev) => {

      }

      tx.onabort = (event: any) => {
        const err = event.target?.error;
        if (err?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      };

      tx.onerror = (event: any) => {
        console.warn(event);
        const err = event.target?.error;
        if (err?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      };

      let store = tx.objectStore('IFSOBSWS_Queue');
      store.getAll().then((res: any) => {
        let queue = res.find((x: any) => x.requestID == obj['requestID']);
        if (queue) {
          obj['queueID'] = queue.queueID;
        } else {
          let ID = (new Date).getTime();
          obj['queueID'] = ID.toString();
        }

        try {
          store.put(obj)
        } catch (e: any) {
          if (e?.name === 'QuotaExceededError') {
            this.handleQuotaExceeded();
          }
        }


      })
    });
  }

  private getQueueIndxdb(): Promise<Object> {
    let promise = new Promise<Object>((resolve) => {
      this.dbxService.openDatabase().then(db => {
        let tx = db.transaction('IFSOBSWS_Queue', 'readwrite');
        let store = tx.objectStore('IFSOBSWS_Queue');
        store.getAll().then(
          (res: QueueData[]) => {
            let list: QueueData[] = [];
            res.forEach((order: QueueData) => {
              list.push(order);
            });
            resolve(list);
          })
      });
    });
    return promise;
  }

  getQueueItemIndxdb(queueId: string): Promise<Object> {
    let promise = new Promise<Object>((resolve) => {
      this.dbxService.openDatabase().then(db => {
        let tx = db.transaction('IFSOBSWS_Queue', 'readwrite');
        let store = tx.objectStore('IFSOBSWS_Queue');
        store.get(queueId).then(
          (res: any) => {
            resolve(res);
          })
      });
    });
    return promise;
  }

  deleteQueueIndxdb(ID: string, requestModule: string, requestID: any, res: any = null): Promise<Object> {
    console.log(`Delete index db queue items...`);
    let promise = new Promise<Object>((resolve) => {

      this.dbxService.openDatabase().then(db => {
        const tx = db.transaction('IFSOBSWS_Queue', 'readwrite');
        tx.oncomplete = (ev) => {
          // correct module and request id should be passed here to perform delete indexdb on respective tables
          this.deleteItemIndexDb(db, requestModule, requestID, res).then(() => {
            resolve(res);
          });
        }
        tx.onerror = (err: any) => {
          console.warn(err);
        }
        let store = tx.objectStore('IFSOBSWS_Queue');
        store.delete(ID).then(
          (res: any) => {
          }
        )
        // return tx.done;// complete;
      });

    });
    return promise;
  }

  callbackFunction(queue: any, response: any) {
    if (this.isResponseValid(response)) {
      console.log('Successful. Executing callback functions...');

      // delete queue item and order in indexdb - successful operation
      this.deleteQueueIndxdb(queue.queueID, queue.requestModule, queue.requestID).then(() => {
        this.updateDataIndexDb(queue.requestModule, queue.requestID, queue.requestID, response);
      })
    } else {
      this.catchError(queue, response.errorMessage[0]);
    }
  }

  updateDataIndexDb(requestModule: any, requestID: any, entityValue: any, res: any = null) {
    console.log(`Executing callback function for ${requestModule} ${entityValue}`);
    switch (requestModule) {
      case Helper.Constants.RequestModules.ORDER:
        // get updated order and save to indexdb if not open request
        let isRequestSubmitted = !isNaN(Number(entityValue.toString()));
        if (isRequestSubmitted) {
          this.getAndSaveOrderToIndexDb(`${Number(entityValue)}`);
        }

        let isTempSubmitted = !isNaN(Number(res.entity.value.toString()));
        if (isTempSubmitted) {
          let tempOrderIDArr = entityValue.split('-');
          let paramObject = {
            orderInfoHeaderId: Number(tempOrderIDArr[0]),
            createUserId: SecurityHelper.GetLoggedInUserData().userID,
            shipId: 0
          }

          this.orderCartService.deleteOrderWSTemp(paramObject).subscribe(
            (res: any) => {
              console.log('successful deletetion order temp', res);
            }
          );
        }
        //reload user notification
        this.commonService.loadUserNotification(`${entityValue}`)
        // reload pending/submitted
        this.commonService.loadOrderOverview(`${entityValue}`)
        break;
      case Helper.Constants.RequestModules.DAILY_MEALS:
        // get updated DM and save to indexdb
        this.getAndSaveDMToIndexDb(`${entityValue}`);
        ////reload user notification
        this.commonService.loadUserNotification(`${entityValue}`)
        // reload pending/submitted
        this.commonService.loadDMOverview(`${entityValue}`)
        break;
      case Helper.Constants.RequestModules.BEGIN_AND_END_STOCK:
        this.commonService.loadUserNotification(`${entityValue}`);
        this.commonService.loadStockOverview(`${entityValue}`);
        break;
      case Helper.Constants.RequestModules.ORDER_OVERVIEW:
        this.commonService.loadUserNotification(`${entityValue}`);
        this.commonService.loadOrderOverview(`${entityValue}`);
        break;
      case Helper.Constants.RequestModules.SHIP_CREW:
        this.commonService.loadUserNotification(`${entityValue}`);
        this.commonService.loadShipCrew(`${entityValue}`);
        break;
      case Helper.Constants.RequestModules.IFS_SURVEY:
        this.commonService.loadUserNotification(`${entityValue}`);
        this.commonService.loadIFSSurvey(`${entityValue}`);
        break;
      case Helper.Constants.RequestModules.SHIP_AUDIT:
        this.commonService.loadUserNotification(`${entityValue}`);
        this.commonService.loadShipAuditOverview(`${entityValue}`);
        break;
      default:
        break;
    }
  }

  catchError(queue: any, res: any) {
    console.error('Error on queue. See details:', queue, res)
    let apiCalls = [];

    let isRequestSubmitted = !isNaN(Number(queue.requestID.toString()));
    //notify users for API Exception
    let type = Helper.Constants.UserNotificationType.FOLLOWUP;

    let title = '';
    if (isRequestSubmitted) {
      title = queue.requestModule + ' #' + queue.requestID;
    } else {
      title = queue.requestModule + ' (New)';
    }

    let message = '';
    message = `${title} - Something went wrong with the transaction. Kindly click this message to cancel the transaction.`; //`${message} - Exception error occured while resyncing of data. Exception Details: ${Helper.stripHtmlTags(res.message)}`;

    let notif = new UserNotifMessageData();
    notif.message = message;
    notif.shipId = SecurityHelper.GetLoggedInUserData().shipID;
    notif.userId = queue.userID;
    notif.userNotificationTypeId = type;
    notif.requestModule = Helper.Constants.RequestModules.EXCEPTION + "-" + queue.queueID.toString();
    //if (isRequestSubmitted) {
    //  notif.requestId = queue.requestID;
    //}
    notif.requestId = queue.requestID;

    let apiCall = {
      api: '/api/security/NotifyAPIException',
      body: notif
    }
    apiCalls.push(apiCall);

    from(apiCalls).pipe(
      concatMap(apiCall => {
        let url = `${Helper.API_URL()}${apiCall.api}`;
        return this.http.post(url, apiCall.body)
          .pipe(
            tap(response => console.log(Helper.deepCopy(response))),
            catchError(async (error: any) => console.log(Helper.deepCopy(error)))
          )
      })
    ).subscribe({
      next: (result: any) => {
        console.log('result', result);
        this.commonService.loadUserNotification(`${result.entity.value}`);
      },
      error: (error: any) => {
        console.log('error', error);
      }
    })
  }

  // Use Observable to update count offline transaction
  private _countOfflineTransaction = new BehaviorSubject<number>(0);
  countOfflineTransaction = this._countOfflineTransaction.asObservable();

  public updateCountOfflineTransaction(value: number) {
    this._countOfflineTransaction.next(value);
  }

  // Use Observable to resyncing status
  private _isResyncing = new BehaviorSubject<boolean>(false);
  isResyncing = this._isResyncing.asObservable();

  public updateIsResyncing(value: boolean) {
    this._isResyncing.next(value);
  }

  public getCountOfflineTransaction(): Promise<Object> {
    let promise = new Promise<Object>((resolve) => {

      this.getQueueIndxdb().then((list: any) => {

        this.updateCountOfflineTransaction(Number(list.length));
        resolve(list.length);

      });

    });
    return promise;
  }

  public resyncData() {
    console.log('Resyncing... Get queue list');
    this.getQueueIndxdb().then((list: any) => {
      from(list).pipe(
        // concatMap used to wait for the fist one to finish before executing to next queue in the list
        concatMap((queue: any) => {

          this.updateIsResyncing(true);

          let url = `${Helper.API_URL()}${queue.api}`;
          let queueDate = new Date(parseInt(queue.queueID));
          let currentDate = new Date();

          const diffTime = Math.abs(currentDate.getTime() - queueDate.getTime());
          const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

          console.log(`Queue date: ${queueDate.toLocaleDateString()} | Days in queue: ${diffDays} | Sending request to: ${queue.api}`);

          return this.http.post(url, queue.param)
            .pipe(
              tap(response =>
                this.callbackFunction(queue, Helper.deepCopy(response))
              ),
              catchError(async (error: any) =>
                this.catchError(queue, error)
              ),
              delay(500),
              map(x => queue), // queueu will be produced in the subscribe result below
            )
        }),
      ).subscribe({
        next: (result: any) => {
        },
        error: (error: any) => {
          console.log('Resync Error');
          this.updateIsResyncing(false);
        },
        complete: () => {
          console.log('Resync Completed');
          this.updateCountOfflineTransaction(0);
          this.updateIsResyncing(false);
        }
      });

    });
  }

  private deleteItemIndexDb(db: any, requestModule: string, requestID: any, res: any): Promise<Object> {
    let promise = new Promise<Object>((resolve) => {
      switch (requestModule) {
        case Helper.Constants.RequestModules.SHIP_CREW:
          this.shipCrewService.deleteShipCrewIndxDb(requestID).then(() => {
            this.shipCrewService.getShipCrewListIntoIndexDb();
            resolve(true);
          })
          break;
        case Helper.Constants.RequestModules.NOTIFICATION_LIST:
          this.deleteNotificationIndxDb(db, requestID);
          resolve(true);
          break;
        case Helper.Constants.RequestModules.ORDER_OVERVIEW:
          if (requestID.toString().endsWith("-T")) {
            let orderId = parseInt(requestID.replace('-T', ''));
            this.orderOverviewService.deleteOpenOrderInfoOverviewIndxDb(orderId).then(() => {
              this.orderOverviewService.getOrderInfoOverviewIntoIndexDb();
              resolve(true);
            })
          } else {
            this.orderOverviewService.deleteSubmittedOrderOverviewIndexDb(requestID).then(() => {
              this.orderOverviewService.getOrderInfoOverviewIntoIndexDb();
              resolve(true);
            })
          }
          break;
        case Helper.Constants.RequestModules.ORDER_LIST_ITEM:
          this.updateOrderListItemCredits(db, res);
          resolve(true);
          break;
        case Helper.Constants.RequestModules.CLAIM:
          this.deleteClaimsIndxDb(db, requestID);
          resolve(true);
          break;
        case Helper.Constants.RequestModules.DAILY_MEALS:
          this.dailyMealsOverviewService.cancelDMOverviewIndxDb(requestID).then(() => {
            this.dailyMealsOverviewService.getDailyMealOverviewIntoIndexDb();
            resolve(true);
          });
          break;
        case Helper.Constants.RequestModules.DAILY_MEALS_SUMMARY:
          this.updateDMSummaryIndxDb(db, requestID);
          this.updateDMOverviewIndxDb(db, requestID);
          resolve(true);
          break;
        case Helper.Constants.RequestModules.ORDER_SURVEY:
          this.updateOrderSurveyIndxDb(db, requestID);
          resolve(true);
          break;
        case Helper.Constants.RequestModules.ORDER:
          this.orderCartService.deleteOrderHeaderIndexDb(requestID).then(() => {
            this.orderCartService.deleteOrderDetailsIndexDb(requestID).then(() => {
              this.orderOverviewService.getOrderInfoOverviewIntoIndexDb();
              resolve(true);
            })
          })
          break;
        case Helper.Constants.RequestModules.BEGIN_AND_END_STOCK:
          this.stocksListService.deleteStockIndexDb(requestID).then(() => {
            this.stocksListService.updateStockOverviewSubmittedIndxDB(requestID, false).then(() => {
              this.stocksOverviewService.getShipBeginEndStockHeaderWithContractCurrencyListIntoIndexDb();
              resolve(true);
            });
          });
          break;
        case Helper.Constants.RequestModules.IFS_SURVEY:
          this.ifsSurveyService.deleteIFSSurveyIndxDb(requestID).then(() => {
            this.ifsSurveyService.saveIsIFSSurveyTakenIndxDb(true);
            resolve(true);
          })
          break;
        case Helper.Constants.RequestModules.SHIP_AUDIT:
          this.auditActionService.updateOverviewIndexDB(Number(requestID), false);
          resolve(true);
          break;
      }
    })
    return promise;
  }
  private deleteNotificationIndxDb(db: any, notificationId: any) {
    let tx = db.transaction('OWS_tblNotification', 'readwrite');
    let store = tx.objectStore('OWS_tblNotification');
    store.get(notificationId).then((r: any) => {
      store.delete(notificationId);
    })
  }
  private updateOrderListItemCredits(db: any, res: any) {
    if (res.entity.list.length > 0) {
      let obj = {
        'orderListItemId': 'Credits',
        'credits': res.entity.list[0].creditsNewOrderListItem,
        'updatedOffline': false
      }

      const tx = db.transaction('OWS_tblOrderListItem', 'readwrite');
      let store = tx.objectStore('OWS_tblOrderListItem');

      tx.onabort = (event: any) => {
        const err = event.target?.error;
        if (err?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      };

      tx.onerror = (event: any) => {
        console.warn(event);
        const err = event.target?.error;
        if (err?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      };

      store.get("Credits").then(
        (credits: any) => {
          if (credits == null) {
            try {
              store.add(obj)
            } catch (e: any) {
              if (e?.name === 'QuotaExceededError') {
                this.handleQuotaExceeded();
              }
            }
          } else {
            try {
              store.put(obj)
            } catch (e: any) {
              if (e?.name === 'QuotaExceededError') {
                this.handleQuotaExceeded();
              }
            }
          }
        })
    }
    //  }
    //});
  }
  private deleteClaimsIndxDb(db: any, claimID: any) {
    let tx = db.transaction('OWS_tblClaims', 'readwrite');
    let store = tx.objectStore('OWS_tblClaims');
    store.get(claimID).then((r: any) => {
      store.delete(claimID);
    })
  }
  private updateDMSummaryIndxDb(db: any, dmfId: any) {
    let tx = db.transaction('OWS_tblDMSummary', 'readwrite');
    let store = tx.objectStore('OWS_tblDMSummary');

    tx.onabort = (event: any) => {
      const err = event.target?.error;
      if (err?.name === 'QuotaExceededError') {
        this.handleQuotaExceeded();
      }
    };

    tx.onerror = (event: any) => {
      console.warn(event);
      const err = event.target?.error;
      if (err?.name === 'QuotaExceededError') {
        this.handleQuotaExceeded();
      }
    };

    store.get(dmfId).then((r: any) => {
      r.isUpdatedOffline = false;
      try {
        store.put(r)
      } catch (e: any) {
        if (e?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      }
    })
  }
  private updateDMOverviewIndxDb(db: any, dmfId: any) {
    let tx = db.transaction('OWS_tblDMOverviewSubmitted', 'readwrite');
    let store = tx.objectStore('OWS_tblDMOverviewSubmitted');
    store.delete(dmfId);
  }
  private updateOrderSurveyIndxDb(db: any, orderHeaderInfoID: any) {
    let tx = db.transaction('OWS_tblSupplierSurvey', 'readwrite');
    let store = tx.objectStore('OWS_tblSupplierSurvey');

    tx.onabort = (event: any) => {
      const err = event.target?.error;
      if (err?.name === 'QuotaExceededError') {
        this.handleQuotaExceeded();
      }
    };

    tx.onerror = (event: any) => {
      console.warn(event);
      const err = event.target?.error;
      if (err?.name === 'QuotaExceededError') {
        this.handleQuotaExceeded();
      }
    };

    store.get(orderHeaderInfoID).then((res: SupplierSurveyDto) => {
      res.isUpdatedOffline = false;

      try {
        store.put(res)
      } catch (e: any) {
        if (e?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      }
    })
  }

  private getAndSaveOrderToIndexDb(orderId: any) {
    this.orderCartService.getOrderHeaderDetails(orderId).subscribe(
      (res: any) => {
        this.orderRequestService.saveOrderHeader(orderId, res.entity.orderInfoHeader[0]);

        this.orderCartService.getOrderDetails(orderId).subscribe(
          (res: any) => {
            res.entity.list.forEach((categoryGroup: any) => {
              categoryGroup.totalBudgetPercentage = 0;
              categoryGroup.categoryGroupTotal = 0;
              categoryGroup.categoryGroupTotalOrderedQuantityKG = 0;
              categoryGroup.categoryGroupTotalProposedNeededESKG = 0;

              categoryGroup.orderInfoDetailByCategory.forEach((category: any) => {
                category.orderInfoDetailBySubCategory.forEach((subCategory: any) => {
                  subCategory.orderInfoDetail.forEach((item: any) => {

                    if (item.orderUnitPrice != 0) {
                      item.orderPrice = item.orderUnitPrice;
                    }

                    if (item.originalQuantity != null) {
                      item.originalSuggestedQuantity = item.orderQuantity;
                    }
                    //if (item.version == 0) {
                    //  item.weightFactor = 1;
                    //}
                    item.isDeletedLocally = item.isDeleted;
                  })
                })
              })
            })
            this.orderCartService.updateOrderDetailIndexDb(orderId, res.entity.list);
          }
        )
      }
    )
  }

  private getAndSaveDMToIndexDb(dmfId: any): void {
    this.dailyMealsEntryService.getDailyMealsAndFeesAndDetails(Number(dmfId)).subscribe(
      (responseList: any) => {
        if (responseList[0].entity.list.length > 0) {
          let dailyMealsAndFees = responseList[0].entity.list[0];
          this.dailyMealsEntryService.updateDailyMealsAndFeesIndexDb(dailyMealsAndFees);
        }
        if (responseList[1].entity.list.length > 0) {
          let dailyMealsAndFeesDetails: any = [];
          responseList[1].entity.list.forEach((dm: any) => {
            dailyMealsAndFeesDetails.push(dm);
          });

          dailyMealsAndFeesDetails.forEach((dm: any) => {
            this.dailyMealsEntryService.updateDailyMealsAndFeesDetailsIndexDb(dm);
          })
        }
      }
    )
  }

  isResponseValid(res: any): boolean {
    let isValid = true;

    if (res.errorMessage.length > 0) {
      isValid = false;
    }

    return isValid;
  }

  notifAPIException(notif: UserNotifMessageData) {
    return this.http.post(Helper.API_URL() + '/api/security/NotifyAPIException', notif);
  }

  handleQuotaExceeded() {
    swal
      .fire({
        title: 'Error',
        html: '<span>IndexedDB storage qouta exceeded.</span>',
        icon: "error",
        confirmButtonText: "OK",
        allowOutsideClick: false,
        allowEscapeKey: false,
      })
      .then((result) => {
        if (result.value) {
        }
      });
  }
}
